import styled from '@emotion/styled';

export const Picture = styled.img`
  max-width: 90%;
  height: auto;
  display: block;
  margin: 10px auto;
  /* @media screen and (min-width: 1200px) {
    max-width: 50%;
  } */
`;